import { Days } from './days.enum';

export const DAY_LABELS_ES = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'] as const;

export const DAY_LABEL_TO_DAY: Record<string, Days> = {
  Lun: Days.monday,
  Mar: Days.tuesday,
  Mié: Days.wednesday,
  Mie: Days.wednesday,
  Jue: Days.thursday,
  Vie: Days.friday,
  Sáb: Days.saturday,
  Sab: Days.saturday,
  Dom: Days.sunday,
};
